import { AGENT_STATE_META } from '../types/agent-state.types';
import type { AgentState } from '../types/agent-state.types';
import { TiaThreadAvatar } from './tia/tia-thread-avatar';

/**
 * What TIA is doing right now, shown IN the thread.
 *
 * The companion header already carries a status line, but it sits at the top of
 * the panel — a few hundred pixels from the composer, which is where someone
 * who just pressed Send is looking. Until this existed the thread showed a bare
 * "…" for the first couple of seconds and then, once a tool chip had come and
 * gone, nothing at all while the model composed its answer. Several seconds of
 * a screen that looks finished but isn't.
 *
 * The label is the same live signal the header uses: the tool narration when a
 * tool is running ("Looking through your leads…"), otherwise the agent state's
 * own label.
 */
export function ThinkingRow({
  state,
  narration,
}: {
  /** Live agent state, so the copy tracks thinking → searching → writing. */
  state: AgentState;
  /** Tool narration, when a tool is running. Takes precedence over the state. */
  narration?: string | null;
}) {
  const label = narration ?? AGENT_STATE_META[state].label;
  return (
    <div
      data-slot='thinking-row'
      data-state={state}
      className='flex items-center gap-1'
    >
      <TiaThreadAvatar />
      <p
        // polite, not assertive: this updates every few seconds and must not
        // interrupt a screen reader mid-sentence.
        role='status'
        aria-live='polite'
        className='text-base text-gray-600 opacity-70'
      >
        {label}
      </p>
    </div>
  );
}
